import { useNavigate, useParams } from 'react-router-dom';

import { EventProvider } from '@/contexts';
import { UploadContentLayout } from '@/layout';

import { CoverPhotos } from '../CoverPhotos';

export const UploadContentCoverPhoto = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/requests`)}>
      <EventProvider eventId={Number(eventId)}>
        <CoverPhotos isMobileView />
      </EventProvider>
    </UploadContentLayout>
  );
};
